import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SidebarContext from "../../store/SidebarContext";
import { useContext } from "react";
import Page from "../../components/DefaultPage/DefaultPage";
import classes from "./UserStats.module.css";
import LoadingPage from "../LoadingPage/LoadingPage";
import UserPHistory from "../../components/UserStatsBackDrops/UserPHistory";
import UserOHistory from "../../components/UserStatsBackDrops/UserOHistory";
import Backdrop from "../../components/BackDrop/BackDrop";
// import MaterialIcon from "react-google-material-icons";
import { FaSearch } from "react-icons/fa";
//import { set } from "firebase/database";

function UserStats() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadedUsers, setLoadedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [tg, i18n] = useTranslation("global");
  const [prizeHistoryIsOpen, setPrizeHistoryIsOpen] = useState(false);
  const [objectiveHistoryIsOpen, setObjectiveHistoryIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;
  const serverPath = protocol + "://" + ip + ":" + port;
  const allUsersPath = serverPath + "/user-stats";
  const { t } = useTranslation("global");

  useEffect(() => {
    setIsLoading(true);
    fetch(allUsersPath)
      .then((response) => {
        return response.json();
      })
      .then((users) => {
        setIsLoading(false);
        setLoadedUsers(Object.values(users));
      });
  }, []);

  function filterUsers(users, searchTerm) {
    return users.filter((user) =>
      user.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  

  function orderUsers(users, orderBy) {
    if (orderBy === "schoolWallet") {
      return users
        .slice()
        .sort((a, b) => b.wallet.schoolWallet - a.wallet.schoolWallet);
    } else if (orderBy === "councilWallet") {
      return users
        .slice()
        .sort((a, b) => b.wallet.councilWallet - a.wallet.councilWallet);
    } else if (orderBy === "marketWallet") {
      return users
        .slice()
        .sort((a, b) => b.wallet.marketWallet - a.wallet.marketWallet);
    } else {
      return users;
    }
  }

  const filteredUsers = filterUsers(loadedUsers, searchTerm);
  const orderedUsers = orderBy
    ? orderUsers(filteredUsers, orderBy)
    : filteredUsers;

  if (isLoading) {
    return (
      <section>
        <LoadingPage />
      </section>
    );
  }

  function backdropOHandlerActivate(val) {
    setPrizeHistoryIsOpen(false);
    setObjectiveHistoryIsOpen(true);
    setSelectedUser(val); // Set selected user name
  }

  function backdropPHandlerActivate(val) {
    setPrizeHistoryIsOpen(true);
    setObjectiveHistoryIsOpen(false);
    setSelectedUser(val); // Set selected user name
  }

  function backdropHandlerDeactivate() {
    setObjectiveHistoryIsOpen(false);
    setPrizeHistoryIsOpen(false);
  }

  return (
    <Page>
      <div style={{ marginTop: "5rem" }}>
        <h1>{t("stats.titles.userOverview")}</h1>
      <div style={{display: "flex", justifyContent: "left", alignItems: "center"}}>
          {/* <MaterialIcon
            className="search-icon"
            icon="search"
            size={24}
            color="rgba(0, 0, 0, 0.54)"
          /> */}
              <input
  className={classes.searchbar}
  type="text"
  placeholder={t("sorter.searchBar.placeholder")}
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  style={{
    background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23000000" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>') no-repeat 5px center`,
    paddingLeft: "30px", // Adjust padding to fit the icon
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "16px", // Adjust font size to fit the icon
    lineHeight: "1.5",
    border: "2px solid #067451",
    borderRadius: "4px",
    boxSizing: "border-box",
    width: "100%",
    height: "36px",
    outline: "none"
  }}
/>
        
        <select value={orderBy} onChange={(e) => setOrderBy(e.target.value)}>
          <option value="" disabled hidden>
            {t("sorter.selectButtonLabels.sortBy")}
          </option>
          <option value="schoolWallet">
            {t("global.wallet.walletSchool")}
          </option>
          <option value="councilWallet">
            {t("global.wallet.walletCouncil")}
          </option>
          <option value="marketWallet">
            {t("global.wallet.walletMarket")}
          </option>
        </select>
        </div>
      </div>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>{tg("stats.titles.Username")}</th>
            <th>{tg("global.wallet.walletSchool")}</th>
            <th>{tg("global.wallet.walletCouncil")}</th>
            <th>{tg("global.wallet.walletMarket")}</th>
            <th>{tg("stats.titles.OHistory")}</th>
            <th>{tg("stats.titles.PHistory")}</th>
          </tr>
        </thead>
        <tbody>
          {orderedUsers.map((val, index) => (
            <tr key={index}>
              <td>{val.name}</td>
              <td>{val.wallet.schoolWallet}</td>
              <td>{val.wallet.councilWallet}</td>
              <td>{val.wallet.marketWallet}</td>
              <td>
                <button onClick={() => backdropOHandlerActivate(val.email)}>
                  {val.name}
                </button>
              </td>
              <td>
                <button onClick={() => backdropPHandlerActivate(val.email)}>
                  {val.name}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {prizeHistoryIsOpen && selectedUser && (
        <UserPHistory
          email={selectedUser}
          cancel={backdropHandlerDeactivate}
          confirm={backdropHandlerDeactivate}
        />
      )}
      {prizeHistoryIsOpen ? (
        <Backdrop cancel={backdropHandlerDeactivate} />
      ) : null}

      {objectiveHistoryIsOpen && selectedUser && (
        <UserOHistory
          email={selectedUser}
          cancel={backdropHandlerDeactivate}
          confirm={backdropHandlerDeactivate}
        />
      )}
      {objectiveHistoryIsOpen ? (
        <Backdrop cancel={backdropHandlerDeactivate} />
      ) : null}
    </Page>
  );
}

export default UserStats;
